export const CAS_LANGUAGE_TOKENS_KEY = 'cas_language_tokens';

export const DEFAULT_LANG_TOKENS = {
  PROGRAM_LABEL: {
    SINGULAR_PROGRAM_LABEL: 'Program',
    PLURAL_PROGRAM_LABEL: 'Programs',
  },
};

export enum ECasTokenForms {
  SINGULAR = 'SINGULAR_',
  PLURAL = 'PLURAL_',
}

export type TLangTokens = typeof DEFAULT_LANG_TOKENS;

export type TLangTokenFormatter = (value: string) => string;
